import { ReactNode } from 'react';
import {
  PageBySlugQuery,
  PageSectionFieldsFragment,
  BannerFieldsFragment,
  TabGroupFieldsFragment,
  PhotoAndTextCardFieldsFragment,
} from 'types/generated';
import { getOr } from '@/utils/options';
import Section from '@/components/Section';
import TveirFyrirEinn from '@/components/2fyrir1';
import { renderBanner, renderPhotoAndTextCard } from '@/contentful/index';
import { Log } from '@/logging/datadog';

type Props = {
  query: PageBySlugQuery;
};

function renderTabsWithCards(tabGroupFragment: TabGroupFieldsFragment): ReactNode {
  return <TveirFyrirEinn data={tabGroupFragment} />;
}

function renderSection(pageSectionFragment: PageSectionFieldsFragment) {
  const childType: string = pageSectionFragment.children?.__typename || '';
  let child: ReactNode | null = null;

  switch (childType) {
    case 'Banner':
      child = renderBanner(pageSectionFragment.children as BannerFieldsFragment);
      break;
    case 'TabGroup':
      child = renderTabsWithCards(pageSectionFragment.children as TabGroupFieldsFragment);
      break;
    case 'PhotoAndTextCard':
      child = renderPhotoAndTextCard(pageSectionFragment.children as PhotoAndTextCardFieldsFragment);
      break;
    default:
      Log.info(`no rendering found for contentful type ${childType}`);
      throw new Error(`no rendering found for contentful type ${childType}`);
      break;
  }

  return (
    <Section
      childrenTypeName={pageSectionFragment.children?.__typename}
      sectionId={getOr(pageSectionFragment.id, '')}
      theme={getOr(pageSectionFragment.background, '')}
      marginTop={getOr(pageSectionFragment.marginTop, 128)}
      marginBottom={getOr(pageSectionFragment.marginBottom, 32)}
      gridType={getOr(pageSectionFragment.gridType as 'centered' | 'full', 'full')}
      key={pageSectionFragment.id}
    >
      {child}
    </Section>
  );
}

const TveirFyrirEinnPage = ({ query }: Props) => {
  const pageCollection = query.pageCollection?.items[0];
  const pageSections: PageSectionFieldsFragment[] = pageCollection?.sectionsCollection
    ?.items as PageSectionFieldsFragment[];

  return pageSections.map((s) => renderSection(s));
};

export default TveirFyrirEinnPage;
